module.exports = __webpack_public_path__ + "img/pin.70fb558c.png";